module.exports = __webpack_public_path__ + "static/img/theme5.c45f8a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/theme5.jpg
// module id = 5ygd
// module chunks = 0